import { useDrawer } from '../../../cdl/Drawer/useDrawer.hook';
import { InviteUser } from '../../../user/list/components/InviteUserButton';
import { translate } from '../../helpers/translate.helper';
import { IconPlus } from '../../icons/cdl/Plus';
import { useShortcutMenu } from '../hooks/useShortcutMenu';

import { CommandItem } from './CommandItem';

export const InviteMember = () => {
    const { push, pop } = useDrawer();
    const { setOpen } = useShortcutMenu();

    return (
        <CommandItem
            Icon={IconPlus}
            onSelect={() => {
                const drawerId = push({
                    header: { title: translate('user.inviteTitle') },
                    content: <InviteUser onSuccess={() => pop(drawerId)} />,
                });
                setOpen(false);
            }}
        >
            {translate('users.invite')}
        </CommandItem>
    );
};
